module.exports = __webpack_public_path__ + "img/nav-wishlist.3d9abbd.webp";